// import Loader from 'common/components/Loader/Loader';
import PageHeader from "common/components/PageHeader/PageHeader";
// import AlertsContext from 'common/contexts/alerts';
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import VehicleForm from "./VehicleForm";

function Vehicle() {
  const { t } = useTranslation();
  const router = useRouter();
  // const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "vehicles",
    id,
    {
      populate: ["user"],
    }
  );

  const back = useCallback(() => {
    if (!error) {
      // setAlert(t('common.saved'), 'success');
      router.navigate("/vehicles");
    } else {
      // setAlert(error, 'danger');
    }
  }, [/* setAlert */ router, error]);

  const onSubmit = useCallback(
    async (dataVehicle: any) => {
      const vehicle = { ...dataVehicle };

      try {
        if (vehicle.id) {
          await updateItem(vehicle.id, vehicle);
        } else {
          await saveItem(vehicle);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return (
    <>
      <PageHeader
        title={t(`common.${item && item.id ? "edit" : "add"}`)}
        subLink={{
          url: "/vehicles",
          icon: "arrow-left",
          label: t("common.back"),
        }}
      />
      {/* <Loader isScreen processing={isFetching} /> */}
      {isFetching && id && !item ? null : (
        <VehicleForm onSubmit={onSubmit} vehicle={item} />
      )}
    </>
  );
}

export default Vehicle;
